<template>
  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdwG8kZ_gEcrLy1dSKq5PPbm7vKlhZmWj6BH9FV6z9LosTfIA/viewform?embedded=true" width="640" height="1024" frameborder="0" marginheight="0" marginwidth="0">Загрузка…</iframe>
</template>
<script>
export default {

};
</script>

